import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'
import { REACT_APP_MP_URL } from '../../config/settings/environment'
import { onShowContingenciesInformationDialog } from './ContingencyExpenseDialog.actions'
import { BoldText, Content, GridContainer, Link } from './ContingencyExpenseDialog.styles'

/**
 * The ContingencyExpenseDialog's container.
 */
const ContingencyExpenseDialog = () => {
  const dispatch = useDispatch()
  const { open } = useSelector(state => state.contingencyExpenseDialog)
  const handleCloseDialog = () => dispatch(onShowContingenciesInformationDialog({ showDialog: false }))

  return (
    <Dialog maxWidth="1064px" open={open} verticalAlign="top" onClose={handleCloseDialog}>
      <Content>
        <Typography fontSize="18px" lineHeight="21px" margin="48px 0 16px" variant="h1">
          ¿Cómo se obtiene la información de esta contingencia?
        </Typography>
        <Typography fontSize="16px" lineHeight="20px" variant="body1">
          Toda la información de esta materia de contingencia se obtiene desde{' '}
          <Link href={REACT_APP_MP_URL}>Mercado Público</Link> en base a las órdenes de compra que{' '}
          <BoldText>hayan sido generadas por cada organismo comprador y respectivamente asignadas</BoldText> a esta
          materia de contigencia. Una orden de compra es un documento electrónico emitido por un organismo comprador a
          un proveedor, en donde se solicita la entrega de un producto o servicio y se detalla su precio, cantidad y
          otras condiciones de entrega. Las órdenes de compra en www.mercadopublico.cl, a partir de las cuales se
          calculan los montos, corresponden a compromisos y no a pagos de los organismos del Estado.
        </Typography>
        <Typography fontSize="18px" lineHeight="21px" margin="24px 0 16px" variant="h1">
          ¿En que se basan las cifras de montos de esta contingencia?
        </Typography>
        <Typography fontSize="16px" lineHeight="20px" variant="body1">
          Los montos indicados en la orden de compra corresponden a compromisos de los organismos, no a pagos. Los
          montos que se presentan en cada uno de los gráficos se obtienen en base a las órdenes de compra que se
          encuentren en los siguientes estados: enviada al proveedor, en proceso, aceptada, solicitud de cancelación y
          recepción conforme. El monto en pesos considera la conversión de las órdenes de compra en otras monedas, según
          el tipo de cambio vigente al momento de la actualización de la información.
        </Typography>
        <GridContainer justifyContent="center" margin="48px 0">
          <Button onClick={handleCloseDialog}>Cerrar</Button>
        </GridContainer>
      </Content>
    </Dialog>
  )
}

export default ContingencyExpenseDialog
